export const CAR_FETCHED_ALL = 'car.FETCH_ALL';
export const CAR_FETCHED_LEASED = 'car.FETCHED_LEASED';
export const CAR_LEASED = 'car.LEASED';
export const CAR_UNLEASED =  'car.UNLEASED';
